import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateChild, UrlTree } from '@angular/router';
import { TopNavigationService } from 'src/app/shared/navigation/top-navbar/top-nav.service';
import { SessionService } from '../../shared/session-service/session.service';
import { role } from '../../shared/constants/role-enum';
import { isRcnSurveyApplication } from 'src/app/shared/lib/custom-tools';
import { combineLatest, forkJoin, Observable } from 'rxjs';
import { ROUTE_URL } from 'src/app/shared/constants/route-constants';
import { ImpersonationService } from '../../shared/impersonation/impersonation.service';
import { filter, map, take, tap } from 'rxjs/operators';
import { UserDataService } from '../services/user-data.service';

@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild {
  pathWithNoMidMenu: Array<string> =
    ['/home', '/admin/user', '/admin/admin-client-user', '/admin/master-activities', '/admin/action-logs', '/surveys/survey-list', '/surveys/respondent-survey', '/surveys/client-sme'];

  constructor(
    private router: Router,
    private _sessionService: SessionService,
    public topNavigationService: TopNavigationService,
    private impersonationService: ImpersonationService,
    private userDataService: UserDataService,
  ) { }
  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    return this.canActivate(childRoute, state);
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.userDataService.userDetails$.pipe(
      filter(({ roleId }) => {
        return roleId !== role.none
      }),
      tap(({ roleId }) => {
        if (isRcnSurveyApplication()) {
          this.setRcnSurveyApplication([roleId]);
        }
        else {
          this.setRcnApplication(state, roleId);
        }
      }),
      map(({ roleId }) => {
        if (!route.data.roles) {
          return true;// { hasRole: true, roleId: roleId };
        }

        return route.data.roles.indexOf(roleId) !== -1; //{ hasRole: route.data.roles.indexOf(roleId) !== -1, roleId: roleId };
      }),
      tap((result) => {
        if (!result) {
          // if (route.queryParams && route.queryParams['viewAs']) {
          //   if (result.roleId === role.clientAdmin || result.roleId === role.clientManager || result.roleId === role.respondent)
          //     this.router.navigate(['page-not-found']);
          // } else {
          this.router.navigateByUrl('');
          // }
        }
      })
    )

  }

  private setRcnSurveyApplication(roleIds: number[]) {
    this.topNavigationService.setStudyNav(false);
    if (!roleIds?.includes(role.respondent)) {
      this.topNavigationService.setStudyNavRight(false);
      this.topNavigationService.setShowFeedback(false);
      return false;
    }
  }

  private setRcnApplication(state: RouterStateSnapshot, roleId: role) {
    if (!this.pathWithNoMidMenu.includes(state.url) && !state.url.toString().endsWith('smeview')) {
      // this.topNavigationService.setStudyNav(true);
    } else {
      this.topNavigationService.setStudyNav(false);
    }


    this.impersonationService.clientManagerModeActive$.pipe(
      take(1),
    ).subscribe((isClientMangerViewActive) => {
      if (isClientMangerViewActive) {
        this.topNavigationService.setIsClientManager(true);
      } else {
        this.topNavigationService.setIsClientManager(roleId === role.clientManager);
        if (state.url.includes(ROUTE_URL.STUDIES)) {
          this.topNavigationService.setIsClientUser(true);
        } else {
          this.topNavigationService.setIsClientUser(roleId === role.respondent);
        }
        this.topNavigationService.setIsClientAdmin(roleId === role.clientAdmin);
      }
    })
  }
}
